import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";

import { countryCodeToFlag } from "../../../utils/countryOptions";
import "./UICountryFlag.scss";

const UICountryFlag = ({ flag, shortCode, className }) => {
  const normalizedShortCode = String(shortCode || "")
    .trim()
    .toLowerCase();
  const imageSrc = useMemo(
    () =>
      /^[a-z]{2}$/.test(normalizedShortCode)
        ? `https://flagcdn.com/w40/${normalizedShortCode}.png`
        : "",
    [normalizedShortCode],
  );
  const [hasImageError, setHasImageError] = useState(false);
  const resolvedFlag = flag || countryCodeToFlag(shortCode);

  useEffect(() => {
    setHasImageError(false);
  }, [imageSrc]);

  if (imageSrc && !hasImageError) {
    return (
      <span className={`ui-country-flag ${className}`} aria-hidden="true">
        <img
          alt=""
          src={imageSrc}
          loading="lazy"
          onError={() => setHasImageError(true)}
        />
      </span>
    );
  }

  if (!resolvedFlag) return null;

  return (
    <span className={`ui-country-flag ${className}`} aria-hidden="true">
      <span>{resolvedFlag}</span>
    </span>
  );
};

UICountryFlag.propTypes = {
  flag: PropTypes.string,
  shortCode: PropTypes.string,
  className: PropTypes.string,
};

UICountryFlag.defaultProps = {
  flag: "",
  shortCode: "",
  className: "",
};

export default UICountryFlag;
